import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/
  {
     key: 'id',
     field: FIELDS.ID,
     title: 'Quote No',
     label: 'Quote No',
     cell: 'navigation',
     sortable: true,
     locked: true,
     hidden: false,
     width: 75,
  },{
     key: 'statusName',
     field: FIELDS.STATUS_NAME,
     title: 'Status',
     label: 'Status',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'quoteDate',
     field: FIELDS.QUOTE_DATE,
     title: 'Quote Date',
     label: 'Quote Date',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'companyName',
     field: FIELDS.COMPANY_NAME,
     title: 'Company',
     label: 'Company',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'taxNumber',
     field: FIELDS.TAX_NUMBER,
     title: 'Tax ID',
     label: 'Tax ID',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'contact',
     field: FIELDS.CONTACT,
     title: 'Contact',
     label: 'Contact',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'contactEmail',
     field: FIELDS.CONTACT_EMAIL,
     title: 'Contact Email',
     label: 'Contact Email',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'salePersonFullName',
     field: FIELDS.SALE_PERSON_FULL_NAME,
     title: 'Sales Person',
     label: 'Sales Person',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'quoteTermsName',
     field: FIELDS.QUOTE_TERMS_NAME,
     title: 'Quote Terms',
     label: 'Quote Terms',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'currencyName',
     field: FIELDS.CURRENCY_NAME,
     title: 'Currency',
     label: 'Currency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'exchangeRate',
     field: FIELDS.EXCHANGE_RATE,
     title: 'Exchange Rate',
     label: 'Exchange Rate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'isAuthorized',
     field: FIELDS.IS_AUTHORIZED,
     title: 'Authorized',
     label: 'Authorized',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'billingAddress',
     field: FIELDS.BILLING_ADDRESS,
     title: 'Billing Address',
     label: 'Billing Address',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingAddress',
     field: FIELDS.SHIPPING_ADDRESS,
     title: 'Shipping Address',
     label: 'Shipping Address',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shipOnCompanyAccount',
     field: FIELDS.SHIP_ON_COMPANY_ACCOUNT,
     title: 'ShipOnCompanyAccount',
     label: 'ShipOnCompanyAccount',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'alwaysShipBy',
     field: FIELDS.ALWAYS_SHIP_BY,
     title: 'Always Ship By',
     label: 'Always Ship By',
     sortable: true,
     hidden: true,
     width: 75,
  },{
     key: 'shippingAccountNumber',
     field: FIELDS.SHIPPING_ACCOUNT_NUMBER,
     title: 'Shipping Acct No',
     label: 'Shipping Acct No',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'trackingNumber',
     field: FIELDS.TRACKING_NUMBER,
     title: 'Tracking Number',
     label: 'Tracking Number',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'subTotal',
     field: FIELDS.SUB_TOTAL,
     title: 'Subtotal',
     label: 'Subtotal',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'totalCharges',
     field: FIELDS.TOTAL_CHARGES,
     title: 'Total Charges',
     label: 'Total Charges',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'total',
     field: FIELDS.TOTAL,
     title: 'Total',
     label: 'Total',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'grossProfit',
     field: FIELDS.GROSS_PROFIT,
     title: 'Gross Profit',
     label: 'Gross Profit',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'gpMargin',
     field: FIELDS.GPMARGIN,
     title: 'GP Margin',
     label: 'GP Margin',
     cell: 'formatPercentage',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'salesTypeName',
     field: FIELDS.SALES_TYPE_NAME,
     title: 'Sales Type',
     label: 'Sales Type',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingProviderName',
     field: FIELDS.SHIPPING_PROVIDER_NAME,
     title: 'Ship Via',
     label: 'Ship Via',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingMethodName',
     field: FIELDS.SHIPPING_METHOD_NAME,
     title: 'Ship Method',
     label: 'Ship Method',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'incoTermsName',
     field: FIELDS.INCO_TERMS_NAME,
     title: 'IncoTerms',
     label: 'IncoTerms',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'active',
     field: FIELDS.ACTIVE,
     title: 'Active',
     label: 'Active',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'authorizedByUserFullName',
     field: FIELDS.AUTHORIZED_BY_USER_FULL_NAME,
     title: 'Authorized By',
     label: 'Authorized By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateAuthorized',
     field: FIELDS.DATE_AUTHORIZED,
     title: 'Date Authorized',
     label: 'Date Authorized',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'DateCreated',
     label: 'DateCreated',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'DateModified',
     label: 'DateModified',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'createdByUserFullName',
     field: FIELDS.CREATED_BY_USER_FULL_NAME,
     title: 'Created By',
     label: 'Created By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'modifiedByUserFullName',
     field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
     title: 'Modified By',
     label: 'Modified By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateEmailed',
     field: FIELDS.DATE_EMAILED,
     title: 'Date Sent',
     label: 'Date Sent',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'comments',
     field: FIELDS.COMMENTS,
     title: 'Comments',
     label: 'Comments',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'internalComments',
     field: FIELDS.INTERNAL_COMMENTS,
     title: 'Internal Comment',
     label: 'Internal Comment',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalLineCost',
     field: FIELDS.TOTAL_LINE_COST,
     title: 'Total Line Cost',
     label: 'Total Line Cost',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'isTaxable',
     field: FIELDS.IS_TAXABLE,
     title: 'Taxable',
     label: 'Taxable',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'taxRate',
     field: FIELDS.TAX_RATE,
     title: 'Tax Rate',
     label: 'Tax Rate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesTaxable',
     field: FIELDS.TOTAL_CHARGES_TAXABLE,
     title: 'Total Charges Tax',
     label: 'Total Charges Tax',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesNonTaxable',
     field: FIELDS.TOTAL_CHARGES_NON_TAXABLE,
     title: 'Total Charges Non Tax',
     label: 'Total Charges Non Tax',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesCost',
     field: FIELDS.TOTAL_CHARGES_COST,
     title: 'Total Charges Cost',
     label: 'Total Charges Cost',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'tax',
     field: FIELDS.TAX,
     title: 'Tax',
     label: 'Tax',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'subTotalConverted',
     field: FIELDS.SUB_TOTAL_CONVERTED,
     title: 'Subtotal Converted',
     label: 'Subtotal Converted',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalLineCostConverted',
     field: FIELDS.TOTAL_LINE_COST_CONVERTED,
     title: 'Total Line Cost Converted',
     label: 'Total Line Cost Converted',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesTaxableConverted',
     field: FIELDS.TOTAL_CHARGES_TAXABLE_CONVERTED,
     title: 'Total Charges Tax Converted',
     label: 'Total Charges Tax Converted',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesNonTaxableConverted',
     field: FIELDS.TOTAL_CHARGES_NON_TAXABLE_CONVERTED,
     title: 'Total Charges Non Tax Converted',
     label: 'Total Charges Non Tax Converted',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesConverted',
     field: FIELDS.TOTAL_CHARGES_CONVERTED,
     title: 'Total Charges Converted',
     label: 'Total Charges Converted',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesCostConverted',
     field: FIELDS.TOTAL_CHARGES_COST_CONVERTED,
     title: 'Total Charges Cost Converted',
     label: 'Total Charges Cost Converted',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalConverted',
     field: FIELDS.TOTAL_CONVERTED,
     title: 'Total Converted',
     label: 'Total Converted',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'buyerTotal',
     field: FIELDS.BUYER_TOTAL,
     title: 'BuyerTotal',
     label: 'BuyerTotal',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'delivery',
     field: FIELDS.DELIVERY,
     title: 'Delivery',
     label: 'Delivery',
     sortable: true,
     hidden: true,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
